import './App.css';
import Home from './Views/Home.js'

function App() {
  return (
      <Home></Home>
  );
}

export default App;
